import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";
import Badge from "./Badge";

export default function SoldWarrantyCard({ data, onView }) {
  const [expanded, setExpanded] = useState(false);

  const statusConfig = {
    Active: { badge: "green", accent: "border-l-emerald-500" },
    Rejected: { badge: "red", accent: "border-l-rose-500" },
    Pending: { badge: "yellow", accent: "border-l-amber-500" },
  };

  const status = statusConfig[data.status] || statusConfig.Pending;

  return (
    <div
      className={`rounded-3xl 
        border border-white/30 
        bg-white/10 
        backdrop-blur-2xl 
        p-4 
        shadow-[0_20px_50px_rgba(31,38,135,0.25)]
        mb-4 
        border-l-4 ${status.accent}
      `}
    >
      {/* HEADER */}
      <div className="flex justify-between items-start gap-2">
        <div>
          <p className="text-sm font-semibold text-slate-900">
            {data.productName}
          </p>
          <p className="text-[11px] text-slate-500">
            Warranty ID: {data.id}
          </p>
        </div>

        <Badge label={data.status} color={status.badge} />
      </div>

      {/* MAIN INFO */}
      <div className="mt-3 grid grid-cols-2 gap-3 text-xs">
        <Info label="Invoice" value={data.saleInvoice} />

        <div>
          <p className="text-slate-500 font-medium">Sold On</p>
          <p className="text-slate-800 font-semibold">
            {data.soldOn?.date || "-"}
          </p>
          <p className="text-[11px] text-slate-500">
            {data.soldOn?.time || ""}
          </p>
        </div>

        {/* AMOUNT (HIGHLIGHT) */}
        <div className="col-span-2 rounded-2xl 
        bg-white/20 
          backdrop-blur-xl 
          border border-white/30 
          p-3 
          flex items-center justify-between
        ">
          <div>
            <p className="text-[11px] text-slate-500">Amount</p>
            <p className="text-lg font-bold text-slate-900">
              ₹{data.amount}
            </p>
          </div>

          <button
            onClick={() => setExpanded((p) => !p)}
            className="flex items-center gap-1 text-xs font-semibold text-blue-600"
          >
            {expanded ? "Less" : "More"}
            {expanded ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
          </button>
        </div>
      </div>

      {/* EXPANDED DETAILS */}
      {expanded && (
        <div className="mt-3 border-t pt-3 grid grid-cols-2 gap-3 text-xs">
          <Info label="Warranty Type" value={data.warrantyType} />
          <Info label="Customer" value={data.registeredBy} />

          {data.rejectReason && (
            <div className="col-span-2 rounded-lg bg-rose-400/10 border border-rose-300/40 backdrop-blur-xl p-2">
              <p className="text-[11px] font-semibold text-rose-600">
                Reject Reason
              </p>
              <p className="text-xs text-rose-800">
                {data.rejectReason}
              </p>
            </div>
          )}
        </div>
      )}

      {/* ACTION */}
      {onView && (
        <button
          onClick={onView}
          className="mt-3 w-full rounded-2xl 
          bg-gradient-to-br from-blue-600 to-indigo-700 
          py-2.5 
          text-sm font-semibold text-white 
          shadow-[0_10px_25px_rgba(37,99,235,0.35)]
          active:scale-[0.97] transition-all duration-300"
        >
          View Details
        </button>
      )}
    </div>
  );
}

/* ---------- Small Info Block ---------- */
function Info({ label, value }) {
  return (
    <div>
      <p className="text-slate-500 font-medium">{label}</p>
      <p className="text-slate-800 font-semibold">{value || "-"}</p>
    </div>
  );
}


// import { useState } from "react";
// import Badge from "./Badge";

// export default function SoldWarrantyCard({ data, onView }) {
//   const [expanded, setExpanded] = useState(false);

//   const badgeColor =
//     data.status === "Active"
//       ? "green"
//       : data.status === "Rejected"
//       ? "red"
//       : "yellow";

//   return (
//     <div className="rounded-xl border border-slate-200 bg-white p-3 space-y-2 shadow-md mb-2">
//       {/* HEADER */}
//       <div className="flex justify-between items-center">
//         <div className="font-semibold text-sm text-slate-800">
//           {data.productName}
//         </div>
//         <Badge label={data.status} color={badgeColor} />
//       </div>

//       {/* PRIMARY FIELDS */}
//       <div className="text-xs text-slate-600 space-y-2">
//         <Field label="Warranty ID" value={data.id} />
//         <Field label="Invoice" value={data.saleInvoice} />

//         <div className="space-y-0.5">
//           <div className="font-medium text-slate-500">Sold On</div>
//           <div className="flex flex-col leading-tight">
//             <span className="text-sm font-medium text-slate-800">
//               {data.soldOn?.date || "-"}
//             </span>
//             <span className="text-xs text-slate-500">
//               {data.soldOn?.time || ""}
//             </span>
//           </div>
//         </div>

//         <Field label="Amount" value={`₹${data.amount}`} />
//       </div>

//       {/* EXTRA FIELDS */}
//       {expanded && (
//         <div className="text-xs text-slate-600 space-y-2 border-t pt-2">
//           <Field label="Warranty Type" value={data.warrantyType} />
//           <Field label="Reject Reason" value={data.rejectReason} />
//           <Field label="Customer" value={data.registeredBy} />
//         </div>
//       )}

//       {/* ACTIONS */}
//       <div className="flex justify-between items-center pt-2">
//         <button
//           onClick={() => setExpanded((p) => !p)}
//           className="text-xs text-blue-600 font-medium"
//         >
//           {expanded ? "View Less" : "View More"}
//         </button>

//         {onView && (
//           <button
//             onClick={onView}
//             className="text-xs px-3 py-1 rounded-md bg-blue-600 text-white"
//           >
//             View
//           </button>
//         )}
//       </div>
//     </div>
//   );
// }

// /* ---------- Small helper for consistency ---------- */
// function Field({ label, value }) {
//   return (
//     <div className="space-y-0.5">
//       <div className="font-medium text-slate-500">{label}</div>
//       <div className="text-slate-800">{value ?? "-"}</div>
//     </div>
//   );
// }



// import ExpandableCard from "./ExpandableCard";

// export default function SoldWarrantyCard({ data, onView }) {
//   const badgeColor =
//     data.status === "Active"
//       ? "green"
//       : data.status === "Rejected"
//       ? "red"
//       : "yellow";

//   return (
//     <ExpandableCard
//       title={data.productName}
//       badge={{ label: data.status, color: badgeColor }}
//       primaryFields={[
//         { label: "Warranty ID", value: data.id },
//         { label: "Invoice", value: data.saleInvoice },
//         {
//           label: "Sold On",
//           value: (
//             <div className="flex flex-col leading-tight">
//               <span className="text-sm font-medium text-slate-800">
//                 {data.soldOn?.date}
//               </span>
//               <span className="text-xs text-slate-500">
//                 {data.soldOn?.time}
//               </span>
//             </div>
//           ),
//         },

//         { label: "Amount", value: `₹${data.amount}` },
//       ]}
//       extraFields={[
//         { label: "Warranty Type", value: data.warrantyType },
//         { label: "Reject Reason", value: data.rejectReason },
//         { label: "Customer", value: data.registeredBy },
//       ]}
//       onView={onView}
//     />
//   );
// }
